export default function Differentials() {
  const differentials = [
    {
      icon: 'ri-goblet-line',
      title: 'Curadoria Premium',
      description: 'Seleção exclusiva de destilados, licores e insumos de alta qualidade'
    },
    {
      icon: 'ri-flask-line',
      title: 'Técnicas Avançadas',
      description: 'Defumação, infusões, espumas artesanais e clarificação'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Menu Exclusivo',
      description: 'Carta personalizada desenvolvida especialmente para seu evento'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipe Profissional',
      description: 'Bartenders especializados com capitão de bar dedicado'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Planejamento Estratégico',
      description: 'Análise prévia de consumo e execução impecável'
    },
    {
      icon: 'ri-award-line',
      title: '+10 Anos de Mercado',
      description: 'Sempre com soluções modernas, inovando e elevando o padrão dos eventos'
    }
  ];

  return (
    <section id="diferenciais" className="py-16 md:py-32 lg:py-48" style={{ background: 'linear-gradient(135deg, #0D0A06 0%, #1A1200 50%, #0D0A06 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="font-serif text-4xl md:text-5xl font-light text-white text-center mb-12 md:mb-16 lg:mb-24">
          Diferenciais
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {differentials.map((item, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] p-8 md:p-10 lg:p-14 transition-all duration-500 hover:border-[#D4AF37] cursor-pointer"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6 md:mb-8 lg:mb-10">
                <i className={`${item.icon} text-[#D4AF37] text-4xl md:text-5xl`}></i>
              </div>
              <h3 className="text-white text-base font-medium uppercase tracking-wider mb-4 md:mb-5">
                {item.title}
              </h3>
              <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}